import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree, } from '@angular/router';
import { ContractorCredentialsService } from '@services/contractor-credentials.service';
import { QrCodeService } from '@artemis-software/wr-api';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QrAccessGuard implements CanActivate {

  readonly router = inject(Router);
  readonly contractorCredentialsService = inject(ContractorCredentialsService);
  readonly qrCodeService = inject(QrCodeService);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const shortcode = this.contractorCredentialsService.getCurrentShortCode();
    const pin = this.contractorCredentialsService.getCurrentPin();
    const routeShortCode = route.paramMap.get('shortCode') ?? shortcode;
    const loginPage = this.router.createUrlTree(['/qr', routeShortCode ?? '']);

    if (!shortcode || !pin || !this.sameShortCode(shortcode, routeShortCode)) {
      return of(loginPage);
    }

    if (this.contractorCredentialsService.isSessionExpired()) {
      this.contractorCredentialsService.clearContractorCredentials();
      return of(loginPage);
    }

    return this.qrCodeService.verifyAccess(shortcode, pin).pipe(
      map(valid => valid ? true : loginPage),
      catchError(() => of(loginPage)),
    );
  }

  private sameShortCode(storedShortCode: string, routeShortCode: string | null): boolean {
    return routeShortCode?.toUpperCase() === storedShortCode.toUpperCase();
  }
}
